// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';


// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import * as Formatters from '../ui/Formatters';

// import * as Formatters from '../ui/Formatters';
import OutlinedPopover from '../ui/OutlinedPopover';
// import classnames from 'classnames';

import * as AccountIcons from '../account/Icons';

// import * as coreSelectors from '../core/selectors';
import * as accountSelectors from '../account/selectors';
import * as accountActions from '../account/actions';
import so from '../so';
import AddIcon from '@material-ui/icons/Add';
import Confirm from '../ui/Confirm';
import {getPaymentMethodBrandOrBankName, getPaymentMethodLast4} from "../ui/Formatters";
import ConfirmSurcharge from "./ConfirmSurcharge";
import * as coreSelectors from "../core/selectors";

const styles = theme => ({
  loadingProgress : {
  },
  loadingLabel : {
    ...theme.typography.body2,
    fontWeight: 'bold',
    marginLeft: 20,
  },
  invoiceTable : {
    borderCollapse: 'collapse',
    '& th' : {
      padding: '3px 20px',
      textAlign: 'left',
    },
    '& td' : {
      padding: '3px 20px',
    },
  },
  money : {
    textAlign: 'right',
  },
  summaryLine : {
    textAlign: 'right',
    fontWeight: 'bold',
  },
  totalLine : {
    borderTop : '1px solid ' + theme.brandingColors.poshBlack,
    borderBottom : '1px solid ' + theme.brandingColors.poshBlack,
  }
});

/*
 * Issue a payment on the selected invoice using a stored payment method
 */

class StoredPayment extends Component {

  state = {
    paymentMethodUid : '',
    invoiceDue : 0,
    amount : 0,
    amountText: '',
    fullPayment : true,
    invoiceId: null,
    displayConfirmation: false,
    paymentSurcharge: {},
    confirmAddPaymentOpen : false,
  }

  componentDidMount() {
    this.checkSelection();
  }
  
  componentDidUpdate() {
    this.checkSelection();
    if (this.state.invoiceId === null || this.state.invoiceId !== this.props.invoice.invoiceId) {
      let amount = so(this.props.invoice, "amountDue", 0);
      this.setState({invoiceId: this.props.invoice.invoiceId,
                     amount: amount,
                     invoiceDue : amount,
                     amountText: amount.toFixed(2)});
    }
  }

  methodExists = (paymentMethodUid) => {
    const methods = this.props.paymentMethods.paymentMethods || [];
    return(methods.some((method) => method.id === this.state.paymentMethodUid));
  }

  checkSelection = () => {
    /* Make sure a selection is in one of the lists or clear it out */
    if (this.state.paymentMethodUid.length > 0) {
      if (!this.methodExists(this.state.paymentMethodUid)) {
        this.setState({paymentMethodUid : ''});
        return;
      }
    }

    /* Select the last used method as the default if it still exists */
    if (this.state.paymentMethodUid.length === 0 &&
        Boolean(this.props.paymentMethods.lastPaymentMethod)) {
      if (this.methodExists(this.props.paymentMethods.lastPaymentMethod)) {
        this.setState({paymentMethodUid : this.props.paymentMethods.lastPaymentMethod});
      } 
    }
  }

  cancelPayment = () => {
    this.props.setStoredPaymentOpen(false);
    this.props.setInvoiceOpen(true);
    this.props.setShowPaymentConfirmation(false);
    this.props.setSurchargeQueried(false);
    this.props.setOkToSubmitPayment(false);
  }

  changePaymentMethod = (event) => {
    this.setState({paymentMethodUid : event.target.value});
  }

  amountChanged = (event) => {
    if (event.target.value.length > 10) {
      return;
    }
    if (event.target.value.match(/^\d*\.?\d{0,2}$/)) {
      let amount = parseFloat(event.target.value);
      if (isNaN(amount)) {
        amount = 0;
      }
      this.setState({amountText: event.target.value, amount});
    }
  }

  querySurcharge = () => {
    const methods = this.props.paymentMethods.paymentMethods || [];
    const method = methods.find(item => item.id === this.state.paymentMethodUid);
    const brand = getPaymentMethodBrandOrBankName(method);
    const last4 = getPaymentMethodLast4(method, false);
    this.props.querySurcharge(this.props.invoice.accountId, this.props.invoice.invoiceId,
                              this.state.paymentMethodUid, this.state.amount, brand, last4);
  }

  submitPayment = () => {
    let obj = this.props.surchargeObject;
    obj.receivedConsent = true;
    obj.consentUserId = this.props.user.userId;
    obj.displayedNotice = true;
    this.props.payInvoice(this.props.invoice.accountId, this.props.invoice.invoiceId,
                          this.state.paymentMethodUid, this.state.amount, this.props.surchargeObject);
  }
  
  render() {
    // eslint-disable-next-line
    const { classes, invoice, storedPaymentOpen, submittingPayment, surchargeObject, showPaymentConfirmation, account } = this.props;
    const { paymentMethodUid } = this.state;
    const methods = this.props.paymentMethods.paymentMethods || [];

    let amountInRange = this.state.amount >= 1 && this.state.amount <= this.state.invoiceDue;

    const displayAmount = (surchargeObj) => {
      if (surchargeObj?.surchargeExemptStatus === 'DEFERRED') {
        return Formatters.formatMoney(surchargeObject?.amount, invoice.currencyCode);
      } else {
        return Formatters.formatMoney(surchargeObject?.totalAmount, invoice.currencyCode);
      }
    }

    return(
      <React.Fragment>
        <Confirm open={this.state.confirmAddPaymentOpen}
                 title='You are leaving this site'
                 confirmLabel = 'OK'
                 text='Clicking OK will redirect your browser to our payment processor to securely collect your payment details.'
                 onCancel={() => this.setState({confirmAddPaymentOpen: false})}
                 onConfirm={() => {
                   this.setState({confirmAddPaymentOpen: false});
                   this.props.redirectToAddPayment(account.accountId);
                 }}  />
        <OutlinedPopover open={storedPaymentOpen}
                         icon={<AccountIcons.InvoiceIcon color='primary' fontSize='large'/>}
                         title={'Invoice ' + invoice.invoiceNumber + ' Payment'}
                         maxWidth='sm'
                         onClose={this.cancelPayment}>
          <MuiCore.Grid container direction='column' spacing={1}>
            
            <MuiCore.Grid item>
              Payment Method
            </MuiCore.Grid>
        
            <MuiCore.Grid item>
              <MuiCore.Select value={paymentMethodUid}
                              label='Payment Method'
                              fullWidth
                              onChange={this.changePaymentMethod}
                              input={<MuiCore.OutlinedInput/>}>
                {methods.map(method =>(
                  <MuiCore.MenuItem key={method.id}
                                    value={method.id}>
                    {method?.displayValue}
                  </MuiCore.MenuItem>                    
                ))}
              </MuiCore.Select>
            </MuiCore.Grid>

            <MuiCore.Grid item>
              Amount (1 - {invoice.amountDue})
            </MuiCore.Grid>
            
            <MuiCore.Grid item>
              <MuiCore.TextField fullWidth value = {this.state.amountText}
                                 onChange={this.amountChanged}
                                 InputProps={{
                                   endAdornment: <MuiCore.InputAdornment position="end">{invoice.currencyCode}</MuiCore.InputAdornment>,
                                 }}/>
                
            </MuiCore.Grid>
            
            <MuiCore.Grid item style={{marginTop: 20}}>
              <MuiCore.Button
                onClick={this.querySurcharge}
                disabled={!Boolean(paymentMethodUid) || !amountInRange || submittingPayment}>
                {submittingPayment ? 'Submitting Payment...' : 'Pay ' + Formatters.formatMoney(this.state.amount, invoice.currencyCode)}
              </MuiCore.Button>
              <MuiCore.Button style={{fontFamily: 'Sofia', marginLeft: 10, fontWeight: 700}} onClick={() => this.setState({confirmAddPaymentOpen: true})}>
                <AddIcon />
                  Add Payment Method
              </MuiCore.Button>
            </MuiCore.Grid>
          
          </MuiCore.Grid>          
        </OutlinedPopover>
        <ConfirmSurcharge
          popupLabel={"Confirm Payment"}
          onSubmit={this.submitPayment}
          onClose={this.cancelPayment}
          open={showPaymentConfirmation}
          body={surchargeObject?.surchargeText}
          buttonText={submittingPayment ? 'Submitting Payment...' : `Pay ${displayAmount(surchargeObject)}`}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    invoice : accountSelectors.getInvoice(state),
    storedPaymentOpen : accountSelectors.getStoredPaymentOpen(state),
    paymentMethods : accountSelectors.getPaymentMethods(state),
    submittingPayment : accountSelectors.getSubmittingPayment(state),
    queryingSurcharge : accountSelectors.getQueryingSurcharge(state),
    surchargeQueried : accountSelectors.getSurchargeQueried(state),
    showPaymentConfirmation : accountSelectors.getShowPaymentConfirmation(state),
    okToSubmitPayment : accountSelectors.getOkToSubmitPayment(state),
    surchargeObject : accountSelectors.getSurchargeObject(state),
    account: accountSelectors.getAccount(state),
    user : coreSelectors.getUser(state),
  });
};

const mapDispatchToProps = {
  setStoredPaymentOpen : accountActions.setStoredPaymentOpen,
  setShowPaymentConfirmation: accountActions.setShowPaymentConfirmation,
  setOkToSubmitPayment : accountActions.setOkToSubmitPayment,
  setSurchargeQueried : accountActions.setSurchargeQueried,
  setInvoiceOpen : accountActions.setInvoiceOpen,
  payInvoice : accountActions.payInvoice,
  redirectToAddPayment : accountActions.redirectToAddPayment,
  querySurcharge : accountActions.querySurcharge,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(StoredPayment));
